// Nome da igreja da sessão, para textos de emails, relatórios e títulos.
import { useAuth } from "../auth/AuthProvider";

export default function useChurchBrand() {
  const { user } = useAuth() || {};
  const church = user?.church || null;
  const name = church?.name || "";
  return {
    name,
    shortName: church?.shortName || name,
    logoUrl: church?.logoUrl || "",
    primaryColor: church?.primaryColor || "",
  };
}
